import { Favicon, Logo } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FaviconComponent } from '../../../sb-editor-tools/favicon/favicon.component';
import { LogoComponent } from '../../../sb-editor-tools/logo/logo.component';
import { ToolsService } from '../../../sb-editor-tools/services/tools.service';
import { Logofavicon } from './models/logofavicon.model';

@Component({
  selector: 'app-sbeditor-tool-logofavicon',
  templateUrl: './logofavicon.component.html',
})
export class LogofaviconComponent implements OnInit {

  @Output() exportTool = new EventEmitter<Logofavicon>();
  @ViewChild("logo",{static:false}) logoComponent: LogoComponent;
  @ViewChild("favicon",{static:false}) faviconComponent: FaviconComponent;

  private logoFavicon:Logofavicon = null
  private subscriptions: Array<Subscription> = [];

  constructor( private toolsService: ToolsService ) { }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.logo && res.favicon){
        this.logoFavicon = {
          logo : Object.assign({},res.logo),
          favicon: Object.assign({},res.favicon)
        }
      }else{
        console.error("Logo or favicon tool not found");
        return;
      }
    });
    this.subscriptions.push(tools$);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  public getTool(){
    this.logoFavicon = {
      logo :  Object.assign({},this.logoComponent.getTool()),
      favicon: Object.assign({},this.faviconComponent.getTool()),
    }
    return this.logoFavicon;
  }
}
